module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image2_after_sale2-7ef54360c57f4d92780605d5baed7143.png";